import React from 'react';
import { CalendarIcon } from 'lucide-react';
export const CtaSection = () => {
  return <div className="mt-16 mb-8" data-id="element-7">
      <div className="rounded-xl overflow-hidden" data-id="element-8">
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-8 text-center" data-id="element-9">
          <h2 className="text-2xl font-bold text-white mb-3" data-id="element-10">
            Ready to Turn Your Simulation into Reality?
          </h2>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto" data-id="element-11">
            Transform your validated strategy into a $100M+ growth trajectory.
            Let's bring this framework to life with our proven engagement
            models.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-12">
            <div className="bg-blue-900 bg-opacity-30 backdrop-blur-sm rounded-lg px-6 py-3" data-id="element-13">
              <div className="text-sm text-blue-200 mb-1" data-id="element-14">Starting from</div>
              <div className="text-2xl font-bold text-white" data-id="element-15">$25,000</div>
              <div className="text-xs text-blue-200 mt-1" data-id="element-16">
                Beta Engagement • 8-12 weeks
              </div>
            </div>
            <button className="bg-white text-blue-600 font-semibold py-3 px-6 rounded-lg hover:bg-blue-50 transition flex items-center" data-id="element-17">
              <CalendarIcon className="w-5 h-5 mr-2" data-id="element-18" />
              Book Strategy Call →
            </button>
          </div>
        </div>
      </div>
    </div>;
};